import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';

// Pages
import HomePage from './pages/HomePage';
import DemoGate, { hasDemoAccess } from './pages/DemoGate';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import RecordsPage from './pages/RecordsPage';
import UploadPage from './pages/UploadPage';
import SearchPage from './pages/SearchPage';
import MigrationPage from './pages/MigrationPage';
import AskPage from './pages/AskPage';
import RecordDetailPage from './pages/RecordDetailPage';
import PublicPortal from './pages/PublicPortal';
import AdminPage from './pages/AdminPage';
import NLSearchPage from './pages/NLSearchPage';
import Layout from './components/Layout';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"/></div>;
  if (!user) return <Navigate to="/demo" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function DemoProtected({ children }) {
  if (!hasDemoAccess()) return <Navigate to="/demo" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/demo" element={<DemoGate />} />
          <Route path="/login" element={<DemoProtected><LoginPage /></DemoProtected>} />
          <Route path="/public" element={<DemoProtected><PublicPortal /></DemoProtected>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="records" element={<RecordsPage />} />
            <Route path="records/:id" element={<RecordDetailPage />} />
            <Route path="upload" element={<ProtectedRoute roles={['admin','staff']}><UploadPage /></ProtectedRoute>} />
            <Route path="search" element={<SearchPage />} />
            <Route path="migration" element={<ProtectedRoute roles={['admin','staff']}><MigrationPage /></ProtectedRoute>} />
            <Route path="ask" element={<AskPage />} />
            <Route path="nl-search" element={<NLSearchPage />} />
            <Route path="admin" element={<ProtectedRoute roles={['admin']}><AdminPage /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
